'use client'

/**
 * HreflangAlternates — rendert canonical + hreflang-Alternates fuer alle 17 Sprachen.
 *
 * Google/Bing/DuckDuckGo/Yandex nutzen hreflang um die richtige Locale-Version
 * einer Seite in den Suchergebnissen zu zeigen. x-default = Fallback.
 *
 * Da FGL client-seitig lokalisiert (kein /en/... URL-Prefix), zeigen alle
 * hreflang-Links auf DIE gleiche URL — Suchmaschine liefert den User dort ab,
 * unser I18nProvider setzt die Locale via Cookie und lokalStorage.
 *
 * r19.55.203 (2026-08-11): GEO-Infrastruktur-Sprint.
 */

import { usePathname } from 'next/navigation'

const ORIGIN = 'https://free-glide-league.com'
const LOCALES = [
  'de', 'en', 'fr', 'it', 'es', 'pt', 'nl', 'fi',
  'sv', 'pl', 'da', 'sl', 'ja', 'ko', 'zh-CN', 'th', 'he',
] as const

export function HreflangAlternates() {
  const pathname = usePathname() || '/'
  const canonical = `${ORIGIN}${pathname === '/' ? '/' : pathname}`

  return (
    <>
      <link rel="canonical" href={canonical} />
      {LOCALES.map((loc) => (
        <link key={loc} rel="alternate" hrefLang={loc} href={canonical} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={canonical} />
    </>
  )
}
